import React from 'react';
import PropTypes from 'prop-types';
import { SIZE_BIG, SIZE_SMALL } from '../constants';
import {
  PRIMARY_COLOR,
  SECONDARY_COLOR_HIGHLIGHT,
  BLACK_COLOR,
} from '../colors';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * UiBarVertical
 * This component displays a vertical bar
 * Props (parameters)
 * level: PropTypes.number.isRequired = (number of bar elements that should be filled)
 * max: PropTypes.number.isRequired = (number of bar elements)
 * title: PropTypes.string
 * size: PropTypes.string = [SIZE_BIG, SIZE_SMALL, SIZE_MEDIUM], by default the SIZE_BIG is used
 * mode: PropTypes.string
 */
export default class UiBarVertical extends React.PureComponent {
  render() {
    const { mode, level, max, title, size } = this.props;
    let colorBarElementFilled = PRIMARY_COLOR;
    let colorBarElementNotFilled = SECONDARY_COLOR_HIGHLIGHT;
    const styleTitle = {
      color: BLACK_COLOR,
    };
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      colorBarElementFilled = colors.BAR_VERTICAL_FILLED;
      colorBarElementNotFilled = colors.BAR_VERTICAL_NOT_FILLED;
      styleTitle.color = colors.TEXT_COLOR;
    }
    const bar = [];
    for (let index = max; index > 0; index -= 1) {
      if (level >= index) {
        bar.push({ color: colorBarElementFilled });
      } else {
        bar.push({ color: colorBarElementNotFilled });
      }
    }
    let classNameContainer = 'big';
    if (size !== SIZE_BIG) {
      classNameContainer = size === SIZE_SMALL ? 'small' : 'medium';
    }
    return (
      <div className={`ui-bar-vertical ${classNameContainer}`}>
        <div className="bar">
          {bar.map((b,i) => (
            <div key={i} className="bar-element" style={{ backgroundColor: b.color }} />
          ))}
        </div>
        <div className="title" style={styleTitle}>
          {title}
        </div>
      </div>
    );
  }
}

UiBarVertical.propTypes = {
  level: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  title: PropTypes.string,
  size: PropTypes.string,
  mode: PropTypes.string,
};

UiBarVertical.defaultProps = {
  mode: null,
  size: SIZE_BIG,
  title: null,
};
